import React from 'react';

interface SettingsDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  allowAddExamples: boolean;
  onToggleAllowAddExamples: (next: boolean) => void;
  allowBatchLabelRenaming: boolean;
  onToggleAllowBatchLabelRenaming: (next: boolean) => void;
}

const SettingsDrawer: React.FC<SettingsDrawerProps> = ({
  isOpen,
  onClose,
  allowAddExamples,
  onToggleAllowAddExamples,
  allowBatchLabelRenaming,
  onToggleAllowBatchLabelRenaming
}) => {
  let version = '0.0.0';
  try {
    // Use package.json version only
    version = require('../../package.json').version;
  } catch {}
  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-transparent"
          style={{ zIndex: 9998 }}
          onClick={onClose}
          aria-hidden="true"
        />
      )}
      <div
        className={`fixed top-0 right-0 h-screen w-80 bg-white shadow-2xl border-l transition-transform ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        } flex flex-col`}
        style={{ zIndex: 10000 }}
      >
      <div className="p-4 border-b flex items-center justify-between">
        <h2 className="text-lg font-medium text-gray-900">Settings</h2>
        <button
          className="px-2 py-1 text-sm text-gray-600 hover:text-gray-900"
          onClick={onClose}
          aria-label="Close settings"
        >
          ✕
        </button>
      </div>

      <div className="p-4 space-y-6 flex-1 overflow-y-auto">
        <div>
          <label className="flex items-center justify-between cursor-pointer">
            <div>
              <div className="text-sm font-medium text-gray-900">Allow adding new examples</div>
              <div className="text-xs text-gray-500">Controls whether "+ new example" appears</div>
            </div>
            <input
              type="checkbox"
              checked={allowAddExamples}
              onChange={(e) => onToggleAllowAddExamples(e.target.checked)}
              className="h-4 w-4"
            />
          </label>
        </div>
        
        <div>
          <label className="flex items-center justify-between cursor-pointer">
            <div>
              <div className="text-sm font-medium text-gray-900">Allow batch label editing</div>
              <div className="text-xs text-gray-500">Edit label name & color across all occurrences</div>
            </div>
            <input
              type="checkbox"
              checked={allowBatchLabelRenaming}
              onChange={(e) => onToggleAllowBatchLabelRenaming(e.target.checked)}
              className="h-4 w-4"
            />
          </label>
        </div>
      </div>
      <div className="p-3 border-t text-xs text-gray-500">
        Version: {version}
      </div>
      </div>
    </>
  );
};

export default SettingsDrawer;


